import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=3ddfa0e0&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=3ddfa0e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddfa0e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ddfa0e0')) {
      api.createRecord('3ddfa0e0', component.options)
    } else {
      api.reload('3ddfa0e0', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=3ddfa0e0&scoped=true", function () {
      api.rerender('3ddfa0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/Dashboard.vue"
export default component.exports